// extracted by mini-css-extract-plugin
export default {"noInventoryAvailable":"_c4033cf0"};